export default __webpack_public_path__ + "static/media/mice_01.5bcc675b.png";